// When the app is opened from a private LAN address (emergency internal link, e.g. http://192.168.9.110),
// it talks to the API on the same server's LAN port 5000. Otherwise (countorasys.com, localhost) nothing changes.
const host = typeof window !== 'undefined' ? window.location.hostname : '';
const isPrivateLanHost = /^(10\.\d+\.\d+\.\d+|192\.168\.\d+\.\d+|172\.(1[6-9]|2\d|3[01])\.\d+\.\d+)$/.test(host);
const API_ORIGIN = isPrivateLanHost ? `http://${host}:5000` : 'https://api.countorasys.com';

const config = {
  API_BASE_URL:          `${API_ORIGIN}/api`,
  API_ORIGIN:            API_ORIGIN,
  CHAT_HUB_URL:          `${API_ORIGIN}/hubs/chat`,
  NOTIFICATIONS_HUB_URL: `${API_ORIGIN}/hubs/notifications`,
  IS_EMERGENCY_LAN:      isPrivateLanHost,
};

export default config;
